import styled from "styled-components";
import { COLORS } from "@/react/theme/constants";

export const InnerContainer = styled.div`
  border: 1px solid ${COLORS.tertiary};
`;

export const ActionTitle = styled.h5`
  padding: 12px;
  border-bottom: 1px solid ${COLORS.tertiary};
`;

export const Paragraph = styled.p`
  margin-bottom: 8px;
  padding: 12px;
`;

export const ActionStrip = styled.div`
  border-top: 1px solid ${COLORS.tertiary};
  padding: 12px;
`;
